import { useRouteError, useNavigate } from "react-router-dom";

export default function ErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();
  console.error("Route error:", error);

  const is404 = error?.toString().includes("404");

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-lg w-full">
        <h1 className="text-2xl font-bold text-red-600 mb-4">
          {is404 ? "Page Not Found" : "Navigation Error"}
        </h1>
        <div className="text-gray-700">
          {is404 ? (
            <>
              <p className="mb-4">The page you're looking for doesn't exist.</p>
              <button
                onClick={() => navigate("/vsl1")}
                className="bg-[#2D4220] text-white px-4 py-2 rounded hover:bg-opacity-90 transition-opacity"
              >
                Go to Home Page
              </button>
            </>
          ) : (
            <>
              <p className="mb-2">Path: {window.location.pathname}</p>
              <p className="mb-2">Referrer: {document.referrer}</p>
              <p className="mb-2">Error: {error?.toString()}</p>
              {error instanceof Error && (
                <>
                  <p className="mb-2">Message: {error.message}</p>
                  <p className="font-mono text-sm bg-gray-100 p-4 rounded">
                    Stack: {error.stack}
                  </p>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
